import { render, staticRenderFns } from "./CopyableLink.vue?vue&type=template&id=09d0b1b0&"
import script from "./CopyableLink.vue?vue&type=script&lang=js&"
export * from "./CopyableLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports